import { combineEpics } from 'redux-observable';
import { stripeSetupIntentRequestEpic } from './StripeSetupIntentEpic/StripeSetupIntentRequestEpic';
import { confirmPaymentMethodRequestEpic } from './ConfirmPaymentMethodEpic/ConfirmPaymentMethodRequestEpic';

export const paymentEpics = combineEpics(stripeSetupIntentRequestEpic, confirmPaymentMethodRequestEpic);
